export default __webpack_public_path__ + "static/media/BG.fd94ba1c.png";